import clsx from 'clsx'
import React, { useEffect, useRef } from 'react'
import { renderPdf } from '~/utils/renderPdf'

const LearnerPdfViewer = ({ url, title, className }) => {
  const pagesRef = useRef(null)

  useEffect(() => {
    const container = pagesRef.current
    if (!url || !container) return undefined

    const controller = new AbortController()
    container.replaceChildren()
    renderPdf(container, url, { signal: controller.signal }).catch(error => {
      if (!controller.signal.aborted) throw error
    })

    return () => controller.abort()
  }, [url])

  return <div ref={pagesRef} className={clsx('overflow-y-auto bg-gray-100', className)} role='document' aria-label={title} />
}

export default LearnerPdfViewer
